// makeCancelable taken from: https://reactjs.org/blog/2015/12/16/ismounted-antipattern.html
export default function makeCancelable(promise) {
  var has_canceled = false;
  var wrapped_promise = new Promise(function (resolve, reject) {
    Promise.resolve(promise).then(function (val) {
      return has_canceled ? reject({
        isCanceled: true
      }) : resolve(val);
    }, function (error) {
      return has_canceled ? reject({
        isCanceled: true
      }) : reject(error);
    });
  });
  return {
    promise: wrapped_promise,
    cancel: function cancel() {
      has_canceled = true;
    }
  };
}